import React from "react";
import useSpeechSynthesis from "../../hooks/useSpeechSynthesis";
import classNames from "classnames";
import { Play, Stop } from "../../assets/svg/icons";

const SpeechSynthesis = ({ text }) => {
  const { speak, voices, cancel, supported, speaking } = useSpeechSynthesis();
  var playBtn = classNames({
    "rs-play": true,
    "rs-speaking": speaking,
  });
  if (!supported) return null;

  var voiceAlvaArray = voices.filter((obj) => {
    return obj.name === "Alva";
  });
  console.log("component: ", speaking);
  return (
    <div className="rs-container">
      <button
        className={playBtn}
        onClick={(e) =>
          speak({
            text: text,
            voice: voiceAlvaArray[0],
            rate: 0.9,
            pitch: 1,
          })
        }
      >
        <span>Lyssna</span>
        <Play aria-hidden="true" />
      </button>
      <button className="rs-stop" onClick={() => cancel()} disabled={!speaking}>
        <span>Stop</span>
        <Stop aria-hidden="true" />
      </button>
    </div>
  );
};

export default SpeechSynthesis;
